<table class="table marginTopTwentyPx packageParticipantListTable">
  <tbody>
    @if (tableName === 'participants') {
      @for (number of rows; track number) {
        <tr class="skeleton-row participants">
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
          <td><ion-skeleton-text class="primary-color-txt" animated></ion-skeleton-text></td>
        </tr>
      }
    }
    @if (tableName === 'documents') {
      @for (number of rows; track number) {
        <tr class="skeleton-row documents">
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
        </tr>
      }
    }
    @if (tableName === 'organizers') {
      @for (number of rows; track number) {
        <tr class="skeleton-row organizers">
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
          <td><ion-skeleton-text animated></ion-skeleton-text></td>
        </tr>
      }
    }
  </tbody>
</table>
